'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PageAddController = function () {
  function PageAddController(ProductPagesDataProvider, $state, Upload, $timeout, API_URL, APPLICATION_URL) {
    "ngInject";

    (0, _classCallCheck3.default)(this, PageAddController);
    this.activeTab = 1;
    this.page = {};
    this.type = 3;
    this.page.products = [];
    this.page.main_category = '';
    this.page.category = '';
    this.page.sub_category = '';
    this.Upload = Upload;
    this.ProductPagesDataProvider = ProductPagesDataProvider;
    this.$state = $state;
    this.$timeout = $timeout;
    this.API_URL = API_URL;
    this.APPLICATION_URL = APPLICATION_URL;
    this.errorShow = 0;
    this.field = 'id';
    this.order_type = 'asc';
    ProductPagesDataProvider.editor();
    var vm = this;
    ProductPagesDataProvider.loadCategoriesNoLimit('0').then(function (result) {
      vm.mainCategories = result;
    });
  }

  (0, _createClass3.default)(PageAddController, [{
    key: 'setActiveTab',
    value: function setActiveTab(tabToSet) {
      this.activeTab = tabToSet;
      this.setEditorsData();
    }
  }, {
    key: 'changeCategory',
    value: function changeCategory() {
      if (this.page.category) {
        var vm = this;
        vm.ProductPagesDataProvider.loadCategoriesNoLimit(this.page.category).then(function (result) {
          vm.categories = result;
        });
      } else {
        this.categories = {};
      }
    }
  }, {
    key: 'onvertToSlug',
    value: function onvertToSlug(text) {
      return text.toString().normalize('NFKD') // Bryt ner bokstäver med diakritiska tecken
      .replace(/[\u0300-\u036f]/g, '') // Ta bort diakritiska tecken (accents)
      .toLowerCase().replace(/å/g, 'a').replace(/ä/g, 'a').replace(/ö/g, 'o').replace(/æ/g, 'ae').replace(/ø/g, 'oe').replace(/\u00fc/g, 'ue').replace(/\s+/g, '-') // Replace spaces with -
      .replace(/[^\w\-]+/g, '') // Remove all non-word chars
      .replace(/\-\-+/g, '-') // Replace multiple - with single -
      .replace(/^-+/, '') // Trim - from start of text
      .replace(/-+$/, ''); // Trim - from end of text
    }
  }, {
    key: 'saveData',
    value: function saveData(productForm, redirect) {
      var vm = this;
      vm.setEditorsData();
      vm.$timeout(function () {
        if (!productForm.$valid) {
          vm.errorShow = 1;
          vm.$timeout(function () {
            vm.errorShow = 0;
          }, 5000);
          return false;
        }
        if (vm.page.name) vm.page.slug = vm.onvertToSlug(vm.page.name);
        if (!vm.page.sub_category) vm.page.sub_category = 0;
        if (!vm.page.alt) vm.page.alt = vm.page.name;
        vm.page.type = vm.type;
        if (vm.page.img) {
          vm.saveWithImage(vm.page.img, redirect);
        } else {
          var saveData = vm.ProductPagesDataProvider.saveProductPage(vm.page);
          saveData.then(function (res) {
            if (redirect == '1') {
              if (res[0] != undefined && res[0].insertId != undefined) vm.$state.go("app.productPageEdit", { id: res[0].insertId, tabId: vm.activeTab });else alert('Please try again.');
            } else {
              vm.$state.go('app.productPagelisting');
            }
          });
        }
      }, 5);
    }
  }, {
    key: 'saveWithImage',
    value: function saveWithImage(file, redirect) {
      var vm = this;
      file.upload = vm.Upload.upload({
        url: vm.API_URL + '/productPage/saveProductPageImage',
        method: 'POST',
        data: {
          filename: new Date().valueOf() + file.name,
          file: file
        }
      });
      file.upload.then(function (response) {
        var data = vm.page;
        data.img = vm.APPLICATION_URL + response.data;
        var result = vm.ProductPagesDataProvider.saveProductPage(data);
        result.then(function (res) {
          if (redirect == '1') {
            if (res[0] != undefined && res[0].insertId != undefined) vm.$state.go("app.productPageEdit", { id: res[0].insertId, tabId: vm.activeTab });else alert('Please try again.');
          } else {
            vm.$state.go('app.productPagelisting');
          }
        });
      }, function (response) {
        if (response.status > 0) alert(response.status + ': ' + response.data);
      });
      //    file.upload.progress(function (evt) {
      //      vm.file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
      //    });
    }
  }, {
    key: 'setEditorsData',
    value: function setEditorsData() {
      this.page.shortText = tinyMCE.get('shortText').getContent();
      this.page.templateText = tinyMCE.get('templateText').getContent();
      this.page.longText = tinyMCE.get('longText').getContent();
      this.page.metaData = tinyMCE.get('metaData').getContent();
    }
  }]);
  return PageAddController;
}();

// WEBPACK FOOTER //


exports.default = PageAddController;


/** WEBPACK FOOTER **
 ** ./client/app/modules/product-page/components/add/controller.js
 **/